import { atom } from "recoil"
import { CriterionFilters } from "../../../../data/model"

export const UNI_SEARCH_TOP_PRODUCTS_KEY = "parts.uniSearchTopProducts.SelectedCriterias"

export const SelectedCriteriasState = atom<CriterionFilters[] | undefined>({
    key: UNI_SEARCH_TOP_PRODUCTS_KEY,
    default: undefined,
})
